import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import { AppAuthProvider } from "./auth/AppAuth";
import { BoardsShell } from "./BoardsShell";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <AppAuthProvider>
      <BoardsShell />
    </AppAuthProvider>
  </StrictMode>,
);
